import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'

import { fetchMonthlyTourReportDailyReports } from '@/features/monthly-tour-reports/api'
import { getMonthlyTourReportQueryOptions } from '@/features/monthly-tour-reports/query-options'
import { calculateReportPeriod } from '@/libs/utils/date-utils'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/'
)({
  loader: async ({
    abortController,
    params: { tenantKey, monthlyTourReportId },
    context: { auth, queryClient }
  }) => {
    // まず月次レポート情報を取得
    const monthlyTourReport = await queryClient.fetchQuery({
      ...getMonthlyTourReportQueryOptions({
        tenantKey,
        monthlyTourReportId
      }),
      // route.tsx で取得処理を行なってるため staleTime を設定して重複リクエストを防ぐ
      staleTime: 500
    })

    // レポート作成時の締日を考慮した期間を計算
    const { operatingYearMonth } = monthlyTourReport
    let operatingDateFrom: string | undefined
    let operatingDateTo: string | undefined

    if (monthlyTourReport.closingDate) {
      // 締日が設定されている場合は締日を考慮した期間計算
      const { startDate, endDate } = calculateReportPeriod(
        new Date(operatingYearMonth),
        monthlyTourReport.closingDate,
        monthlyTourReport.oldClosingDate ?? undefined,
        monthlyTourReport.closingDateEffectiveFrom
          ? new Date(monthlyTourReport.closingDateEffectiveFrom)
          : undefined
      )
      operatingDateFrom = format(startDate, 'yyyy-MM-dd')
      operatingDateTo = format(endDate, 'yyyy-MM-dd')
    }

    // 計算した期間で日次レポートを取得
    const dailyReports = await fetchMonthlyTourReportDailyReports(
      {
        tenantKey,
        monthlyTourReportId,
        query: {
          operatingDateFrom,
          operatingDateTo
        }
      },
      abortController.signal
    )

    return {
      authUser: auth.user,
      monthlyTourReport,
      dailyReports
    }
  }
})
